import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBy1s2OC5Q8hMczJq8WxADLRAIM6vDUHNg",
  authDomain: "gaffer-llc.firebaseapp.com",
  projectId: "gaffer-llc",
  storageBucket: "gaffer-llc.firebasestorage.app",
  messagingSenderId: "390732703457",
  appId: "1:390732703457:web:f7c39ed3a317e9fc2d79a0",
  measurementId: "G-YEHDDZ5R9K"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

export default app;